<template>
    <q-item
        class="NewDropdownSelectOption"
        :class="{
            'NewDropdownSelectOption--focused': scope.focused,
            'NewDropdownSelectOption--first': scope.index === 0,
        }"
        :active-class="['NewDropdownSelectOption--active', activeClass].filter(Boolean).join(' ')"
        v-bind="scope.itemProps"
    >
        <q-item-section
            class="NewDropdownSelectOption__content"
            :class="{
                '!justify-start': justifyContent === 'start',
                '!justify-end': justifyContent === 'end',
                '!justify-center': justifyContent === 'center',
            }"
        >
            <Checkbox
                v-if="multiSelect"
                :model-value="scope.selected"
                :disabled="scope.itemProps.disable"
                v-on="{ click: scope.itemProps.onClick, mousemove: scope.itemProps.onMousemove }"
            />
            <slot name="label">
                <q-item-label
                    :class="{
                        'text-white': scope.focused,
                        'text-[#2d3e50]': !scope.focused,
                    }"
                >
                    {{ scope.opt.label }}
                </q-item-label>
            </slot>
        </q-item-section>
    </q-item>
</template>

<style lang="scss">
    $content-padding: 15px;
    $border-color: rgba(0, 0, 0, 0.1);

    .NewDropdownSelectOption {
        padding-top: 4px;
        padding-bottom: 4px;
        position: relative;

        &::after {
            content: "";
            display: block;
            width: calc(100% - $content-padding * 2);
            height: 1px;
            background: $border-color;
            position: absolute;
            top: 0;
            left: $content-padding;
        }

        &--first {
            &::after {
                display: none;
            }
        }

        &__content {
            padding: 5px $content-padding;
            display: flex;
            align-items: center;
            flex-flow: row;
            z-index: 10;
            border-radius: 6px;

            .q-item__label {
                overflow-wrap: anywhere;
                word-break: break-word;
            }
        }

        &.NewDropdownSelectOption--active {
            // quasar adds a primary color to the selected item
            color: unset;
        }

        &.NewDropdownSelectOption--focused {
            .q-focus-helper {
                // We override the q-select style that uses !important
                background: #2eb495 !important;
                opacity: 0 !important;

                &::before,
                &::after {
                    // We override the q-select style that uses !important
                    opacity: 0 !important;
                }
            }

            .NewDropdownSelectOption__content {
                // We override the q-select style that uses !important
                background: #2eb495 !important;
            }
        }
    }
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { QItem, QItemSection, QItemLabel } from 'quasar';

    import Checkbox from '../Checkbox/Checkbox.vue';

    export default defineComponent({
        name: 'NewDropdownSelectOption',
        components: {
            QItem,
            QItemSection,
            QItemLabel,
            Checkbox,
        },
        props: {
            scope: {
                type: Object as PropType<any>,
                required: true,
            },
            multiSelect: {
                type: Boolean,
                default: false,
            },
            justifyContent: {
                type: String as PropType<'start' | 'end' | 'center'>,
                default: 'start',
            },
            activeClass: {
                type: String as PropType<string | undefined>,
                required: false,
                default: undefined,
            },
        },
    });
</script>
